<template>
  <base-home-page>
    <template v-if="!showMessage">
      <h1 class="mt-0 text-center">Forgot your password?</h1>
      <p>Enter your email address and we'll send you a link to reset your password.</p>
      <form>
        <div class="form-group">
          <label for="email">Email Address:</label>
          <input v-model="email" id="email" type="text" class="form-control" />
        </div>
        <button class="btn btn-block btn-primary" @click.prevent="submitForm">
          Reset Password
        </button>
      </form>
    </template>
    <template v-else>
      <p class="text-success">
        If there is an account associated with {{ email }} you will receive an email with a link to
        reset your password.
      </p>
    </template>
    <hr />
    <router-link :to="{ name: 'home' }" class="text-center">
      <i class="fas fa-arrow-left"></i> Back to sign in</router-link
    >
  </base-home-page>
</template>
<script>
  import BaseHomePage from '@shared/BaseHomePage.vue';

  export default {
    name: 'ForgotPassword',

    data() {
      return {
        email: '',
        showMessage: false,
        showError: false,
      };
    },

    components: {
      BaseHomePage,
    },

    methods: {
      submitForm() {
        $.ajax({
          url: '/capsiminbox/authoring-platform/forgot-password',
          method: 'post',
          data: JSON.stringify({ email: this.email }),
          dataType: 'json',
          contentType: 'application/json',
        })
          .done(() => (this.showMessage = true))
          .catch((error) => (this.showError = true));
      },
    },
  };
</script>
